<template>
	<div class="profileWrapper contentPage">

		<template v-if="$inWindow(DATE.WINTER)">
			<snow-wrap/>
		</template>

		<div class="snowMain">
			<account-announcement
					v-if="isAnnouncement && eventsListModLength"
					:items="eventsListMod"
			></account-announcement>
			<div class="tabBlock">
				<div class="tabs-header-guard"
				     @touchstart.stop
				     @touchmove.stop.prevent
				     @wheel.stop>

					<v-tabs
							touchless
							v-touch="{ left: () => {}, right: () => {} }"
							v-if="getTabList"
							class="tabList no-swipe-tabs"
							v-model="tab"
							center-active
							height="40"
							show-arrows
							@change="handleTabChange"
					>
						<v-tabs-slider color="#4CAF50"></v-tabs-slider>
						<v-tab
								v-for="item in getTabList.filter(tab => !tab.hidden)"
								:key="item.tab"
								:href="item.href"
								class="tab"
								:class="{'errorTab': item.error}"
						>
							<div v-if="item.icon" class="icon">
								<svg-sprite :icon-id="item.icon" width="20" height="20"></svg-sprite>
							</div>
							<div class="text">{{ item.text }}</div>
							<span v-if="item.tab === 'tabAllUsersComments' && accountCountNotes > 0" class="badge" >
			            {{ accountCountNotes }}
			        </span>
							<span v-if="item.tab === 'tabVacation' && accountCountVacation > 0" class="badge" >
			            {{ accountCountVacation }}
			        </span>
						</v-tab>
					</v-tabs>

					<v-tabs-items v-model="tab">
						<v-tab-item  @touchstart.stop @touchmove.stop value="tabHome">
							<account-tab-home
									:key="tabKeys['tabHome']"
									@updateCalendarEventIconBtn="onCalendarEventIconBtn"
									@updateViewDuties="onViewDuties"
									@updateRequestVacation="onRequestVacation"
									@updateOpenEditPassword="onOpenEditPassword"
									:userData="userData"
							/>
						</v-tab-item>

						<v-tab-item  @touchstart.stop @touchmove.stop value="tabMyInformation">
							<keep-alive>
								<account-tab-my-information :key="tabKeys['tabMyInformation']" />
							</keep-alive>
						</v-tab-item>

						<v-tab-item  @touchstart.stop @touchmove.stop value="tabUsers">
							<keep-alive>
								<account-tab-users :key="tabKeys['tabUsers']" />
							</keep-alive>
						</v-tab-item>

						<v-tab-item  @touchstart.stop @touchmove.stop value="tabSalaryHistory">
							<keep-alive>
								<account-tab-salaryHistory :key="tabKeys['tabSalaryHistory']" :user="userData"/>
							</keep-alive>
						</v-tab-item>

						<v-tab-item  @touchstart.stop @touchmove.stop value="tabStatementsItems">
							<keep-alive>
								<account-tab-statements-items :key="tabKeys['tabStatementsItems']" :user="userData"/>
							</keep-alive>
						</v-tab-item>

						<v-tab-item  @touchstart.stop @touchmove.stop value="tabStatementsItemsManager">
							<keep-alive>
								<account-tab-statements-items
										:key="tabKeys['tabStatementsItemsManager']"
										:user="userData"
										isManagerTab
								/>
							</keep-alive>
						</v-tab-item>

						<v-tab-item  @touchstart.stop @touchmove.stop value="tabStatements">
							<keep-alive>
								<account-tab-statements :key="tabKeys['tabStatements']" />
							</keep-alive>
						</v-tab-item>

						<v-tab-item  @touchstart.stop @touchmove.stop value="tabVacation">
							<keep-alive>
								<account-tab-vacation
										:key="tabKeys['tabVacation']"
										@updateVacationRequest="onVacationRequest"
								/>
							</keep-alive>
						</v-tab-item>

						<v-tab-item  @touchstart.stop @touchmove.stop value="tabCalendarEvents">
							<keep-alive>
								<account-tab-calendar-events :key="tabKeys['tabCalendarEvents']" />
							</keep-alive>
						</v-tab-item>

						<v-tab-item  @touchstart.stop @touchmove.stop value="tabBonusCharge">
							<keep-alive>

							<account-tab-bonus-charge :key="tabKeys['tabBonusCharge']" :user="userData"/>
							</keep-alive>
						</v-tab-item>

						<v-tab-item  @touchstart.stop @touchmove.stop value="tabMyAccountSettings">
							<keep-alive>
								<account-tab-my-settings :key="tabKeys['tabMyAccountSettings']" />
							</keep-alive>
						</v-tab-item>

						<v-tab-item  @touchstart.stop @touchmove.stop value="tabAllUsersComments">
							<keep-alive>
								<account-tab-all-users-comments :key="tabKeys['tabAllUsersComments']"></account-tab-all-users-comments>
							</keep-alive>
						</v-tab-item>

						<v-tab-item  @touchstart.stop @touchmove.stop value="tabGeo">
							<keep-alive>
								<account-tab-geo :key="tabKeys['tabGeo']"></account-tab-geo>
							</keep-alive>
						</v-tab-item>
					</v-tabs-items>

				</div>
			</div>

		</div>

		<request-vacation
				v-if="isRequestVacation"
				@updateClose="onRequestVacationClose"
				@updateDayComment="onSendRequestVacation"
				:total-vocation="total_vocation"
				:active-item="accountVacationRequestEdit"
				:id="idVacationRequest"
				:userData="userData"
		></request-vacation>

		<view-duties
				v-if="isViewDuties"
				:duties="duties"
				:department="department"
				@updateClosePopup="onCloseViewDuties"
		></view-duties>

		<edit-contact
				v-if="isEditContact"
				:item="editContact"
				@updateClose="onEditContactClose"
				@updateDayComment="onSendEditContact"
		></edit-contact>

		<account-day-chat
				v-if="isAccountDayChat"
				:employee-id="employee_id"
				:active-item="activeItem"
				@updateClose="onAccountDayChatClose"
				@updateSave="onAccountDayChatSave"
		></account-day-chat>

		<profile-edit-password
				v-if="isEditPassword"
				@closeDrawer="onCloseEditPassword"
		></profile-edit-password>

	</div>
</template>
<script>

// components
import { defineAsyncComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import { PERMISSIONS } from "@/constants/constants";
import { DATE } from "@/constants/date";

import AccountAnnouncement from "@/pages/Account/Announcement/Announcement";
import RequestVacation from "@/pages/Account/Drawers/RequestVacation.vue";
// import ViewDuties from "@/pages/Account/Dialogs/ViewDuties.vue";
import EditContact from "@/pages/Account/Drawers/EditContact.vue";
import AccountDayChat from "@/shared/AccountDayChat/AccountDayChat.vue";
import ProfileEditPassword from "@/components/Profile/ProfileEditPassword/ProfileEditPassword.vue";
import SnowWrap from "@/shared/Christmas/snowWrap.vue";

export default {
	name: "Account",
	components: {
		SnowWrap,
		ProfileEditPassword,
		AccountDayChat,
		EditContact,
		// ViewDuties,
		RequestVacation,
		AccountAnnouncement,

		ViewDuties: defineAsyncComponent(() => import("@/pages/Account/Dialogs/ViewDuties.vue")),

		AccountTabGeo: defineAsyncComponent(() => import("@/pages/Account/Tabs/AccountTabGeo.vue")),
		AccountTabAllUsersComments: defineAsyncComponent(() => import("@/pages/Account/Tabs/AccountTabAllUsersComments.vue")),
		AccountTabMySettings: defineAsyncComponent(() => import("@/pages/Account/Tabs/AccountTabMySettings.vue")),
		AccountTabStatements: defineAsyncComponent(() => import("@/pages/Account/Tabs/AccountTabStatements.vue")),
		AccountTabBonusCharge: defineAsyncComponent(() => import("@/pages/Account/Tabs/AccountTabBonusCharge.vue")),
		AccountTabSalaryHistory: defineAsyncComponent(() => import("@/pages/Account/Tabs/AccountTabSalaryHistory.vue")),
		AccountTabVacation: defineAsyncComponent(() => import("@/pages/Account/Tabs/AccountTabVacation.vue")),
		AccountTabCalendarEvents: defineAsyncComponent(() => import("@/pages/Account/Tabs/AccountTabCalendarEvents.vue")),
		AccountTabStatementsItems: defineAsyncComponent(() => import("@/pages/Account/Tabs/AccountTabStatementsItems.vue")),
		AccountTabHome: defineAsyncComponent(() => import("@/pages/Account/Tabs/AccountTabHome/AccountTabHome.vue")),
		AccountTabMyInformation: defineAsyncComponent(() => import("@/pages/Account/Tabs/AccountTabMyInformation.vue")),
		AccountTabUsers: defineAsyncComponent(() => import("@/pages/Account/Tabs/AccountTabUsers.vue"))

	},
	computed: {
		...mapGetters([
			'userData',
			'managerData',
			'isCustomers',
			'permissions',
			'permissionsDefault',
			'eventsList',
			'accountCountNotes',
			'accountCountVacation',
			'total_vocation',
			'accountVacationRequestEdit',
		]),

		getTabList() {
			const permissions = this.permissions || {};

			return [
				{
					text: 'My',
					tab: 'tabHome',
					href: '#tabHome',
					icon: 'icon-user',
					hidden: false
				},
				{
					text: 'My Info',
					tab: 'tabMyInformation',
					href: '#tabMyInformation',
					icon: 'setting',
					hidden: !permissions[PERMISSIONS.ACCOUNT_MY_INFO]
				},
				{
					text: 'Users',
					tab: 'tabUsers',
					href: '#tabUsers',
					icon: 'users0',
					// hidden: !permissions[PERMISSIONS.ACCOUNT_USERS]
					hidden: false
				},
				{
					text: 'My st-ts',
					tab: 'tabStatementsItems',
					href: '#tabStatementsItems',
					icon: 'dollar-sign',
					hidden: false
				},
				{
					text: 'Manager st-ts',
					tab: 'tabStatementsItemsManager',
					href: '#tabStatementsItemsManager',
					icon: 'dollar-sign',
					hidden: !(this.userData && this.userData.department_id === 2)
				},

				{
					text: 'St-ts',
					tab: 'tabStatements',
					href: '#tabStatements',
					icon: 'dollar-sign',
					hidden: !permissions[PERMISSIONS.ACCOUNT_ST_TS]
				},
				{
					text: 'Bonus/Charge',
					tab: 'tabBonusCharge',
					href: '#tabBonusCharge',
					icon: 'icon-plus',
					hidden: !permissions[PERMISSIONS.ACCOUNT_BONUS_CHARGE]
				},
				{
					text: 'Salary History',
					tab: 'tabSalaryHistory',
					href: '#tabSalaryHistory',
					icon: 'dollar-sign',
					hidden: !permissions[PERMISSIONS.ACCOUNT_SALARY_HISTORY]
				},
				{
					text: 'Vacation',
					tab: 'tabVacation',
					href: '#tabVacation',
					icon: 'Umbrella',
					hidden: !permissions[PERMISSIONS.ACCOUNT_VACATION]
				},
				{
					text: 'Events',
					tab: 'tabCalendarEvents',
					href: '#tabCalendarEvents',
					icon: 'calendarAlt',
					hidden: !permissions[PERMISSIONS.ACCOUNT_EVENTS]
				},
				// {
				// 	text: 'Settings',
				// 	tab: 'tabMyAccountSettings',
				// 	href: '#tabMyAccountSettings',
				// 	icon: 'setting',
				// 	hidden: false
				// },
				{
					text: 'Comments',
					tab: 'tabAllUsersComments',
					href: '#tabAllUsersComments',
					icon: 'icon-comments',
					hidden: !permissions[PERMISSIONS.ACCOUNT_COMMENTS]
				},
				{
					text: 'Geo',
					tab: 'tabGeo',
					href: '#tabGeo',
					icon: 'mapPin',
					hidden: !permissions[PERMISSIONS.ACCOUNT_GEO]
				},
			];
		}
	},
	data: () => ({
		DATE,
		isEditPassword: false,
		isEditContact: false,
		editContact: null,
		isViewDuties: false,
		isAnnouncement: true,
		isRequestVacation: false,
		eventsListMod: null,
		tab: "tabHome", // Начальный активный таб
		tabKeys: {
			tabHome: 0,
			tabMyInformation: 0,
			// tabUsers: 0,
			tabSalaryHistory: 0,
			tabStatementsItems: 0,
			tabStatements: 0,
			tabVacation: 0,
			tabCalendarEvents: 0,
			tabBonusCharge: 0,
			tabAllUsersComments: 0,
		},
		activeItem: null,
		employee_id: null,
		isAccountDayChat: false,
		dateCalendar: null,
		duties: null,
		department: null,
		idVacationRequest: null,
	}),
	methods: {
		...mapActions([
			'getEvents',
			'getAccountDayChatNote',
			'getUpdateCalendar',
			'getCountNotes',
			'getAccountUpdateVacationRequestEdit',
		]),
		// async handleTabChange(newTab) {
		// 	// Увеличиваем ключ только для открываемого таба
		// 	if (newTab === "tabSalaryHistory"
		// 			|| newTab === "tabStatements"
		// 			|| newTab === "tabStatementsItems"
		// 			|| newTab === "tabBonusCharge"
		// 			|| newTab === "tabAllUsersComments"
		// 			|| newTab === "tabVacation"
		// 			|| newTab === "tabHome") {
		// 		this.$set(this.tabKeys, newTab, this.tabKeys[newTab] + 1);
		// 	}
		// 	await this.getCountNotes();
		// },

		onOpenEditPassword() {
			this.isEditPassword = true;
		},
		onCloseEditPassword() {
			this.isEditPassword = false;
		},

		async handleTabChange(newTab) {
			localStorage.setItem('lastActiveTab', newTab); // збереження активного таба для кнопок назад

			// Проверяем, требует ли вкладка обновления данных при открытии
			const tabsToReload = [
				"tabBonusCharge",
				"tabStatementsItems",
				"tabStatements",
				"tabSalaryHistory",
				"tabAllUsersComments",
				"tabVacation",
				"tabHome"
			];

			if (tabsToReload.includes(newTab)) {
				this.$set(this.tabKeys, newTab, this.tabKeys[newTab] + 1);
			}

			await this.getCountNotes();
		},

		async onVacationRequest(item) {
			const { id } = item;
			this.idVacationRequest = id;
			await this.getAccountUpdateVacationRequestEdit({ id });
			this.isRequestVacation = true;
		},
		eventsListModLength() {
			return this.eventsListMod.length > 0;
		},
		onCloseViewDuties() {
			this.isViewDuties = false;
		},
		onViewDuties({ duties, department }) {
			this.duties = duties;
			this.department = department;
			this.isViewDuties = true;
		},
		onCalendarEventIconBtn(args) {
			const { key, item, employee_id, date } = args;
			this.activeItem = item;
			this.employee_id = employee_id;
			this.dateCalendar = date;

			if (key === 'comment') {
				this.isAccountDayChat = true;
			}
		},
		onAccountDayChatClose() {
			this.isAccountDayChat = false;
		},
		async onAccountDayChatSave(args) {
			this.isAccountDayChat = false;
			await this.getAccountDayChatNote(args);
			const date = this.dateCalendar;
			await this.getUpdateCalendar({ date });
			await this.getCountNotes();
		},
		onRequestVacation() {
			this.activeItem = null;
			this.idVacationRequest = null;
			this.isRequestVacation = true;
		},
		onEditContactClose() {
			this.isEditContact = false;
		},
		onSendEditContact() {
			this.isEditContact = false;
		},
		onRequestVacationClose() {
			this.isRequestVacation = false;
		},
		onSendRequestVacation() {
			this.isRequestVacation = false;
		},
		updateEventsList() {
			const today = moment(); // Текущая дата

			const getBirthdayThisYear = date_true => {
				const birthday = moment(date_true, "YYYY-MM-DD").year(today.year());
				return birthday.isBefore(today, 'day') ? birthday.add(1, 'year') : birthday;
			};

			const sortedItems = this.eventsList
				.map(item => {
					const itemDate = moment(item.date_true, "YYYY-MM-DD");
					const isToday = itemDate.format("MM-DD") === today.format("MM-DD"); // Сравниваем только месяц и день

					return {
						...item,
						today: isToday, // Совпадает ли месяц и день
						nextBirthday: getBirthdayThisYear(item.date_true) // Ближайший день рождения
					};
				})
				.sort((a, b) => a.nextBirthday.diff(b.nextBirthday)); // Сортируем по ближайшему дню рождения

			this.eventsListMod = sortedItems;
		},
		updateActiveTabFromHash() {
			const hash = window.location.hash.slice(1); // Убираем #
			const validTabs = this.getTabList.map(item => item.tab); // Получаем список вкладок
			this.tab = validTabs.includes(hash) ? hash : 'tabHome'; // Устанавливаем вкладку
			// this.tab = validTabs.includes(hash) ? hash : 'tabStatements'; // Устанавливаем вкладку
		},

	},

	created() {
		this.updateActiveTabFromHash();
	},
	beforeRouteUpdate(to, from, next) {
		// фикс шоб при актівному хешу, прикліку по лунке не перекудувало на 1 таб
		if (to.path === from.path && !to.hash) {
			next(false); // Зупиняємо зміну маршруту, якщо тільки хеш змінюється
		} else {
			next();
		}
	},
	async mounted() {
		console.log(navigator.platform);
		console.log(navigator.userAgent);
		if (!this.permissions || !PERMISSIONS) {
			console.warn('permissions или PERMISSIONS недоступны. Проверьте их загрузку.');
		}

		this.updateActiveTabFromHash();
		window.addEventListener('hashchange', this.updateActiveTabFromHash);

		await this.getEvents();

		if (this.eventsList) {
			this.updateEventsList();
		}
		
		window.addEventListener('hashchange', this.updateActiveTabFromHash);

		this.updateActiveTabFromHash(); // Устанавливаем вкладку при загрузке
		window.addEventListener("hashchange", this.updateActiveTabFromHash);

 	},

	beforeDestroy() {
		window.removeEventListener("hashchange", this.updateActiveTabFromHash);
	},
	watch: {
		'$route.hash': 'updateActiveTabFromHash', // Если используется Vue Router
	},
};
</script>
<style lang="scss">

.profileWrapper {
	.tabBlock {

			.tabs-header-guard {
				height: 100%;

			}
			.v-tabs-items {
				height: calc(100% - 59px);
				.v-window__container {
					height: 100%;
					div#tabUsers {
						height: 100%;
					}
				}
			}

	}
}

</style>

<style lang="scss" scoped>

@import "styles/account";
.badge {
	background-color: #e91e63;
	color: white;
	border-radius: 50%;
	padding: 0;
	font-size: 10px;
	position: absolute;
	top: 0;
	right: 0;
	display: flex;
	line-height: 1;
	align-items: center;
	justify-content: center;
	width: 16px;
	height: 16px;
}

.theme--dark.v-tabs-items {
	background: transparent;
}

.profileWrapper {
	position: relative;
	height: 100%;
	min-height: 100%;
	display: block;
}

.snowMain {
	height: 100%;
	position: relative;
	z-index: 5;
	display: flex;
	flex-direction: column;
}

/* тільки вертикальний скрол, жодних горизонтальних свайпів */
.tabs-header-guard {
	touch-action: pan-y;
	overscroll-behavior: contain;
}
.no-swipe-tabs {
	/* інколи Safari реагує саме на контейнер табів */
	touch-action: pan-y;
}
#app .profileWrapper .v-tabs-items {
	background-color: transparent;
}
</style>

